'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _elementAttachmentActions = require('../../element/elementAttachmentActions');

var _OptimisticImage = require('./OptimisticImage');

var _OptimisticImage2 = _interopRequireDefault(_OptimisticImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Actions


// Components


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchCleanElementAttachment: function dispatchCleanElementAttachment(id) {
            return dispatch((0, _elementAttachmentActions.cleanElementAttachment)({ id: id }));
        }
    };
};

var ElementImage = function (_React$Component) {
    _inherits(ElementImage, _React$Component);

    function ElementImage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ElementImage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ElementImage.__proto__ || Object.getPrototypeOf(ElementImage)).call.apply(_ref, [this].concat(args))), _this), _this.cleanElementAttachment = function () {
            var _this$props = _this.props,
                dispatchCleanElementAttachment = _this$props.dispatchCleanElementAttachment,
                element = _this$props.element;

            dispatchCleanElementAttachment(element.get('id'));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ElementImage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                element = _props.element,
                children = _props.children,
                size = _props.size,
                imageType = _props.imageType,
                forcedWidth = _props.forcedWidth,
                forcedHeight = _props.forcedHeight;


            var imageData = element.getIn(['content', 'image']);
            var attachmentData = element.get('attachment');

            return _react2.default.createElement(
                _OptimisticImage2.default,
                {
                    imageType: imageType,
                    imageDetails: imageData,
                    attachmentDetails: attachmentData,
                    onImageLoadCb: this.cleanElementAttachment,
                    size: size,
                    forcedWidth: forcedWidth,
                    forcedHeight: forcedHeight },
                children
            );
        }
    }]);

    return ElementImage;
}(_react2.default.Component);

ElementImage.propTypes = {
    element: _propTypes2.default.object.isRequired,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    dispatchCleanElementAttachment: _propTypes2.default.func,
    dispatchClearError: _propTypes2.default.func,
    imageType: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.number.isRequired,
    forcedWidth: _propTypes2.default.number,
    forcedHeight: _propTypes2.default.number
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ElementImage);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/ElementImage.js
// module id = 437
// module chunks = 0